import { getDefaultConfig } from './Store';

//userTypes for qa and prod: 'new', 'existing', 'churned'
//userTypes for staging: 'stagingNew', 'stagingExisting', 'stagingChurned'
export const getUserType = (hasActiveSubscription, isChurnedUser) => {
  const { appEnv } = getDefaultConfig();

  let userType = 'new';
  if (hasActiveSubscription) {
    userType = 'existing';
  } else if (isChurnedUser) {
    userType = 'churned';
  }

  if (appEnv === 'staging') {
    userType = `staging${userType.charAt(0).toUpperCase() + userType.substring(1)}`;
  }

  return userType;
};
